import React from "react";
import { compose } from "recompose";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import withData from "./withData";
import { CurrencySymbol, formatCurrency, formatDate } from "services/util";
import LineItems from "./LineItems";
import { withSelectedOrganisation } from "../../components/withSelectedOrganisation";
import MainHeader from "./MainHeader";
import HeaderData from "./HeaderData";

export const ReceiveTransactionReceipt = ({
  item,
  contact,
  organisation,
  taxRates,
  settings,
  t,
  ...props
}) => {
  return (
    <DocumentRenderer {...props}>
      <div className="container-fluid m-0 p-0">
        <MainHeader item={item} company={organisation} client={contact} taxRates={taxRates} t={t} settings={settings} doc_name={'RECEIPT'} logo={props.selectedOrganisation.logo} >
          <HeaderData className="mb-1" label="Payment Date" value={formatDate(item.Date)} />
          <HeaderData className="mb-1" label="Send Date" value={formatDate(item.Date)} />
          <HeaderData className="mb-1" label="Reference" value={item.Reference} />
        </MainHeader>
        <div className="row">
          <div className="col-6">
            <div className="border-dark border-top border-bottom p-2 font-weight-bold d-flex justify-content-end">
              <span className="mr-5">
                <Trans>Total</Trans> <CurrencySymbol currency={item.CurrencyCode}/>
              </span>{" "}
              <span>{formatCurrency(item.Total)}</span>
            </div>
          </div>
        </div>
        <LineItems invoice={item} taxRates={taxRates} lang={props.language}/>
      </div>
    </DocumentRenderer>
  );
}

const enhance = compose(withData, withSelectedOrganisation());

export default enhance(ReceiveTransactionReceipt);
